import COLOR from "./color.constant";

export const TEMPLATE_MODE = {
  Normal: {
    name: 'normal',
    iconHeader: '/images/icon-dark-mode.png',
    background: COLOR.BLACK,
    colorHover: COLOR.BLACK,
    backgroundRound: COLOR.WHITE,
    borderColorRound: COLOR.BLACK,
  },
  Dark: {
    name: 'dark',
    iconHeader: '/images/icon-dark-mode-2.png',
    background: COLOR.WHITE,
    colorHover: COLOR.WHITE,
    backgroundRound: COLOR.BLACK,
    borderColorRound: COLOR.WHITE,
  },
};

export const MODE = {
  Normal: 'normal',
  Dark: 'dark',
};
